module.exports = __webpack_public_path__ + "img/1.25c90b7.jpg";